export const config = Object.freeze({
  env: import.meta.env.MODE,
  apiUrl: import.meta.env.VITE_API_URL,
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN,
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  auth0TenantId: import.meta.env.VITE_AUTH0_TENANT_ID,
  permissionsClaim: "permissions",
  rolesClaim: "http://lithologiq/roles",
});

export type AppConfig = typeof config;
